export const apis = {
  AUTH: process.env.REACT_APP_AUTH_URI || `auth.crunchy.ninja/api`,
  CUSTOMERSETTING: process.env.REACT_APP_CUSTOMERSETTING_URI || `customersetting.crunchy.ninja/api`,
};
